import { Flex, View } from '@adobe/react-spectrum';
import moment from 'moment';
import { truncateText } from '../../../../utils/helperUtil';
import styles from './card_component.module.css';
import { ChevronRight } from 'react-bootstrap-icons';
import { Badge } from 'react-bootstrap';
import { InvoiceType } from '../Invoice.hooks';

interface ICardComponentProps {
  item: any;
  invoiceType?: string;
}

const CardComponent: React.FC<ICardComponentProps> = ({ item, invoiceType }) => {

  return (
    <Flex direction="column" position={'absolute'} width={'100%'} alignItems={'start'} justifyContent={'start'} UNSAFE_className={styles.card_list}>
      <Flex direction={'row'} position={'relative'} width={'100%'} alignItems={'center'} justifyContent={'start'} UNSAFE_className={styles.card_child_wrapper}>
        <View
          position={'absolute'}
          margin={'0px'}
          height={'calc(100% - 36px)'}
          width={'4px'}
          top={'18px'}
          bottom={'18px'}
          left={'-1px'}
          maxHeight={'100%'}
          zIndex={1}
          UNSAFE_style={{ backgroundColor: (item.statusName === 'Aktivní' || item.statusName === 'aktivní' || item.statusName === 'active' || item.statusName === 'Active') ? '#1976D2' : '#B0BEC5', borderRadius: '3px' }}
        />
        <Flex direction={'column'} width={'100%'} alignSelf={'stretch'} alignItems={'start'} justifyContent={'start'} gap={'10px'} zIndex={1}>
          <Flex direction={'column'} alignSelf={'stretch'} alignItems={'start'} justifyContent={'start'} gap={'12px'}>
            <Flex direction={'row'} alignSelf={'stretch'} alignItems={'center'} justifyContent={'start'} gap={'8px'}>
              <View flex={1} position={'relative'} UNSAFE_className={styles.heading_text}>
                {item.customerName && truncateText(item.customerName, 30)}
              </View>
              <View position={'relative'} UNSAFE_className={styles.heading_date}>
                {(item.issuedDate && moment(item.issuedDate).format('DD.MM.YYYY'))}
              </View>
            </Flex>
            <Flex direction={'row'} alignItems={'center'} justifyContent={'start'} gap={'6px'} UNSAFE_className={styles.header_path_wrapper}>
              <View position={'relative'} UNSAFE_className={styles.header_path_text}>
                <span title={`${item.folderName} > ${item.projectName}`}>
                  {truncateText(item.folderName, 25)} {item.project && <ChevronRight size={12} />} {truncateText(item.projectName, 25)}
                </span>
              </View>
            </Flex>
          </Flex>
          <View position={'relative'} alignSelf={'stretch'} height={'1px'} UNSAFE_className={styles.header_divider}></View>
          <Flex direction={'row'} width={'100%'} alignItems={'stretch'} justifyContent={'space-between'} gap={'6px'}>
            {(invoiceType === InvoiceType.INVOICE_ISSUED || invoiceType === InvoiceType.OFFER_ISSUED || invoiceType === InvoiceType.ORDER_RECEIVED) ?
              (<Flex direction={'row'} alignItems={'center'} justifyContent={'center'}>
                <Flex direction={'row'} alignItems={'center'} justifyContent={'center'} gap={'6px'}>
                  {item?.invoiceNumber && (
                    <>
                      <Badge
                        style={{ display: "div", alignItems: "center", }}
                        className={styles.greyBadge}
                      >
                        <span >{item.invoiceNumber}</span>
                      </Badge>
                      <Badge
                        style={{ display: "div", alignItems: "center", }}
                        className={styles.greyBadge}
                      >
                        <span >{item.journalName}</span>
                      </Badge>
                    </>

                  )}
                </Flex>
              </Flex>) : (
                <Flex direction={'row'} alignItems={'center'} justifyContent={'center'}>
                  <Flex direction={'row'} alignItems={'center'} justifyContent={'center'} gap={'6px'}>
                    {item?.externalNumber && (
                      <>
                        <Badge
                          style={{ display: "div", alignItems: "center", }}
                          className={styles.greyBadge}
                        >
                          <span >{item.externalNumber}</span>
                        </Badge>
                        <Badge
                          style={{ display: "div", alignItems: "center", }}
                          className={styles.greyBadge}
                        >
                          <span >{item.journalName}</span>
                        </Badge>
                      </>
                    )}
                  </Flex>
                </Flex>
              )
            }
            <Flex
              direction="row"
              alignItems="center"
              justifyContent="center"
              gap="6px"
              UNSAFE_className={`${styles.footer_wrapper} invoiceFooter`}
            >
              <View UNSAFE_className={styles.footer_text_1}>
                <span title="total">Total</span>
              </View>

              {item.totalWithVAT ? (
                <>
                  <View
                    width="2px"
                    height="20px"
                    UNSAFE_className={`${styles.pipe_sign} invoicePipe`}
                  />
                  <div className={`${styles.footer_text_2} invoiceFooterValue`}>
                    {item.currency} {item.totalWithVAT}
                  </div>
                </>
              ) : (
                <View
                  width="2px"
                  height="20px"
                  UNSAFE_className={styles.pipe_sign_transparent}
                />
              )}
            </Flex>

          </Flex>
        </Flex>
      </Flex>
      <View UNSAFE_style={{ height: '10px' }} />
    </Flex>
  )
};

export default CardComponent;
